import { v4 as uuidv4 } from 'uuid'
import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined'
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined'
import PaidOutlinedIcon from '@mui/icons-material/PaidOutlined'
import { ROUTE_PATHS } from 'utils/constants/index'
import StarBorderOutlinedIcon from '@mui/icons-material/StarBorderOutlined'
import EuroIcon from '@mui/icons-material/Euro'
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts'
import SportsEsportsIcon from '@mui/icons-material/SportsEsports'
import CircleOutlinedIcon from '@mui/icons-material/CircleOutlined'
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest'
// import SportsIcon from '@mui/icons-material/Sports'
import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined'
import ReportIcon from '@mui/icons-material/Report'
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount'

const permissions = {
  game: ['read', 'create'],
  admin: ['read', 'create'],
  chat: ['read', 'create'],
  client: ['read', 'create'],
  clientReport: ['read'],
  currency: ['read', 'create'],
  dashboard: ['read'],
  gameConfig: ['read', 'create'],
  gameReport: ['read'],
  operator: ['read', 'create'],
  operatorAdmin: ['read', 'create'],
  operatorReport: ['read'],
  player: ['read', 'create'],
  playerReport: ['read'],
  registrationReport: ['read'],
  transaction: ['read'],
  whitelist: ['read', 'create'],
  generalReport: ['read']
}

export const permissionMap = {
  dashboard: 'dashboard',
  Report: 'report',
  Transaction: 'transaction',
  Player: 'player',
  Admin: 'admin',
  Operator: 'operator',
  operatorAdmin: 'operatorAdmin',
  Client: 'client',
  game: 'game',
  gameConfig: 'gameConfig',
  currency: 'currency',
  Chat: 'chatLanguage',
  clientReport: 'clientReport',
  gameReport: 'gameReport',
  playerReport: 'playerReport',
  registrationReport: 'registrationReport',
  operatorReport: 'operatorReport',
  generalReport: 'generalReport'
}

export const adminSidebarOptions = [
  {
    key: uuidv4(),
    label: 'dashboard',
    path: ROUTE_PATHS.dashboard,
    icon: DashboardOutlinedIcon,
    subMenus: []
  },
  {
    key: uuidv4(),
    label: 'Report',
    icon: ReportIcon,
    subMenus: [
      {
        key: uuidv4(),
        label: 'generalReport',
        path: ROUTE_PATHS.generalReports,
        icon: CircleOutlinedIcon,
        subMenus: []
      },
      {
        key: uuidv4(),
        label: 'clientReport',
        path: ROUTE_PATHS.clientReports,
        icon: CircleOutlinedIcon,
        subMenus: []
      },
      {
        key: uuidv4(),
        label: 'gameReport',
        path: ROUTE_PATHS.gameReport,
        icon: CircleOutlinedIcon,
        subMenus: []
      },
      {
        key: uuidv4(),
        label: 'playerReport',
        path: ROUTE_PATHS.playerReport,
        icon: CircleOutlinedIcon,
        subMenus: []
      },
      {
        key: uuidv4(),
        label: 'operatorReport',
        path: ROUTE_PATHS.operatorReport,
        icon: CircleOutlinedIcon,
        subMenus: []
      },
      {
        key: uuidv4(),
        label: 'registrationReport',
        path: ROUTE_PATHS.registrationReport,
        icon: CircleOutlinedIcon,
        subMenus: []
      }
    ]
  },
  {
    key: uuidv4(),
    label: 'Transaction',
    icon: PaidOutlinedIcon,
    path: ROUTE_PATHS.transactions,
    subMenus: []
  },
  {
    key: uuidv4(),
    label: 'Player',
    icon: GroupsOutlinedIcon,
    subMenus: [
      {
        key: uuidv4(),
        label: 'playerList',
        path: ROUTE_PATHS.players,
        icon: CircleOutlinedIcon
      }
    ]
  },
  {
    key: uuidv4(),
    label: 'Admin',
    path: ROUTE_PATHS.admins,
    icon: SupervisorAccountIcon,
    subMenus: [
      {
        key: uuidv4(),
        label: 'allAdmins',
        path: ROUTE_PATHS.admins,
        icon: CircleOutlinedIcon
      }
    ]
  },
  {
    key: uuidv4(),
    label: 'Operator',
    path: ROUTE_PATHS.operators,
    icon: StarBorderOutlinedIcon,
    subMenus: []
  },
  {
    key: uuidv4(),
    label: 'operatorAdmin',
    path: ROUTE_PATHS.operatorAdmins,
    icon: ManageAccountsIcon,
    subMenus: []
  },
  {
    key: uuidv4(),
    label: 'Client',
    path: ROUTE_PATHS.clients,
    icon: GroupsOutlinedIcon,
    subMenus: []
  },
  {
    key: uuidv4(),
    label: 'game',
    path: ROUTE_PATHS.gamesList,
    icon: SportsEsportsIcon,
    subMenus: []
  },
  {
    key: uuidv4(),
    label: 'gameConfig',
    path: ROUTE_PATHS.gameSettings,
    icon: SettingsSuggestIcon,
    subMenus: [
      {
        key: uuidv4(),
        label: 'Game Settings',
        path: ROUTE_PATHS.gameSettings,
        icon: CircleOutlinedIcon,
        subMenus: []
      },
      {
        key: uuidv4(),
        label: 'Multi Game Settings',
        path: ROUTE_PATHS.multipleGameSettings,
        icon: CircleOutlinedIcon,
        subMenus: []
      }
    ]
  },
  {
    key: uuidv4(),
    label: 'currency',
    path: ROUTE_PATHS.currencies,
    icon: EuroIcon,
    subMenus: []
  },
  {
    key: uuidv4(),
    label: 'Chat',
    icon: ChatBubbleOutlineOutlinedIcon,
    subMenus: [
      {
        key: uuidv4(),
        label: 'Language Rooms',
        path: ROUTE_PATHS.chatLanguageRoom,
        icon: CircleOutlinedIcon,
        subMenus: []
      }
    ]
  }
].filter(option => {
  const permissionKey = option.label.toLowerCase().replace(/\s+/g, '')
  if (permissionKey === 'report') {
    const hasReportPermission = option.subMenus.some(submenu => {
      const submenuPermissionKey = permissionMap[submenu.label]
      return permissions[submenuPermissionKey]?.includes('read')
    })
    return hasReportPermission
  }

  // General case for other options
  const hasPermission = Object.keys(permissions).some(key =>
    key.toLowerCase().replace(/\s+/g, '') === permissionKey && permissions[key]?.includes('read')
  )
  return hasPermission
})

export const operatorSidebarOptions = [
  {
    key: uuidv4(),
    label: 'dashboard',
    path: ROUTE_PATHS.operatorDashboard,
    icon: DashboardOutlinedIcon,
    subMenus: []
  },
  {
    key: uuidv4(),
    label: 'Reports',
    icon: ReportIcon,
    subMenus: [
      {
        key: uuidv4(),
        label: 'Game Reports',
        path: ROUTE_PATHS.gameReport,
        icon: CircleOutlinedIcon,
        subMenus: []
      },
      {
        key: uuidv4(),
        label: 'Player Reports',
        path: ROUTE_PATHS.playerReport,
        icon: CircleOutlinedIcon,
        subMenus: []
      },
      {
        key: uuidv4(),
        label: 'Registration Reports',
        path: ROUTE_PATHS.registrationReport,
        icon: CircleOutlinedIcon,
        subMenus: []
      }
    ]
  },
  {
    key: uuidv4(),
    label: 'Players',
    icon: GroupsOutlinedIcon,
    subMenus: [
      {
        key: uuidv4(),
        label: 'playerList',
        path: ROUTE_PATHS.players,
        icon: CircleOutlinedIcon
      }
    ]
  },
  {
    key: uuidv4(),
    label: 'Transactions',
    path: ROUTE_PATHS.operatorTransactions,
    icon: PaidOutlinedIcon,
    subMenus: []
  },
  {
    key: uuidv4(),
    label: 'Chat',
    icon: ChatBubbleOutlineOutlinedIcon,
    subMenus: [
      {
        key: uuidv4(),
        label: 'Chat Rules',
        path: ROUTE_PATHS.chatRules,
        icon: CircleOutlinedIcon,
        subMenus: []
      },
      {
        key: uuidv4(),
        label: 'User Chats',
        path: ROUTE_PATHS.playerChats,
        icon: CircleOutlinedIcon,
        subMenus: []
      },
      {
        key: uuidv4(),
        label: 'Offensive Words',
        path: ROUTE_PATHS.offensiveWords,
        icon: CircleOutlinedIcon,
        subMenus: []
      }
    ]
  }
]
